import React from 'react';
import PropTypes from 'prop-types';
import TextField from 'components/pages/ResourceSetting/Widgets/TextField';

export default function DescriptionField({
  value,
  onChange,
  disabled,
  required,
}) {
  return (
    <TextField
      title="標題敘述"
      description="限40個半形文字"
      value={value}
      onChange={onChange}
      required={required}
      disabled={disabled}
      maxLength={40}
    />
  );
}

DescriptionField.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
  required: PropTypes.bool,
};

DescriptionField.defaultProps = {
  value: '',
  onChange: () => {},
  disabled: false,
  required: true,
};
